export default __webpack_public_path__ + "static/media/all-categories.2261089a.svg";